/* eslint-disable */
import { makeStateKey, TransferState } from '@angular/core';
import type { LocalizationApiService } from '@dev-fast/backend-services';
import type { TranslateLoader } from '@ngx-translate/core';
import type { Observable } from 'rxjs';
import { catchError } from 'rxjs';
import { DEFAULT_LANGS, type ILocales } from '@dev-fast/types';

class CustomTransLoader implements TranslateLoader {
  private static readonly DEFAULT_LOCALE_KEY = 'default-locale';
  private readonly CURRENT_LANGUAGE_KEY = makeStateKey<ILocales>('currentLang');

  constructor(
    private readonly localizationApiService: LocalizationApiService,
    private readonly transferState: TransferState,
  ) {}

  getTranslation(lang: string): Observable<object> {
    if (lang === CustomTransLoader.DEFAULT_LOCALE_KEY) {
      return this.#handleDefaultLocale();
    }

    return this.localizationApiService.getTranslation(lang).pipe(catchError(() => this.#getTranslationsFromAssets(lang)));
  }

  #handleDefaultLocale(): Observable<object> {
    const storedLanguage = this.transferState.get<ILocales | undefined>(this.CURRENT_LANGUAGE_KEY, undefined);

    return this.#getTranslationsFromAssets(storedLanguage?.path || DEFAULT_LANGS['en'].path);
  }

  #getTranslationsFromAssets(lang: string): Observable<object> {
    return this.localizationApiService
      .getTranslationFromAssets(lang)
      .pipe(catchError(() => this.localizationApiService.getTranslationFromAssets(DEFAULT_LANGS['en'].path)));
  }
}

export function customTranslateLoader(localizationApiService: LocalizationApiService, transferState: TransferState): TranslateLoader {
  return new CustomTransLoader(localizationApiService, transferState);
}
